import $api from "../http";
import { ICreateStaffModel } from "../models/Staff";
import { IUpdateCustomerModel, IUserForClientsTable } from "../models/User";

class ClientsServiceClass {
  async createClient(model: Omit<ICreateStaffModel, "phoneCountryCode" | "phoneNumber">) {
    return $api.post<boolean>(`api/users/customer/create`, model);
  }

  async getAllClients(
    searchValue: string,
    currentPage: number | undefined,
    pageSize: number | undefined
  ) {
    return $api.get<{ customers: IUserForClientsTable[]; total: number }>(
      `api/users/customer/get-all?searchValue=${searchValue}&currentPage=${currentPage}&pageSize=${pageSize}`
    );
  }

  async getClientById(id: string) {
    return $api.get<IUserForClientsTable>(`api/users/customer/get-by-id/${id}`);
  }

  async updateClient(id: string, model: IUpdateCustomerModel) {
    return $api.put<boolean>(`api/users/customer/update/${id}`, model);
  }

  async deleteClient(id: string) {
    return $api.delete<boolean>(`api/users/customer/delete/${id}`);
  }
}

export const ClientsService = new ClientsServiceClass();
